// Task groups and tasks (admin pages): shared labels here, the list and group pages in group.ts,
// a task's page in task.ts.
import type { RequirementState, Source, StepKind, TaskStatus } from "../../../../tasks/model";
import approvalCard from "./approvalCard";
import waiting from "./waiting";
import subtasks from "./subtasks";
import cards from "./cards";
import create from "./create";
import group from "./group";
import task from "./task";
import toolchains from "./toolchains";

export default {
  source: { manual: "Manual", github: "GitHub Issues", jira: "Jira", asana: "Asana" } satisfies Record<Source, string>,
  requirementState: {
    bound: "Bound",
    platform: "Platform key",
    unbound: "Not bound (optional)",
    missing: "Missing",
    broken: "Broken",
    not_enforced: "Not enforced yet",
    recorded: "Recorded",
  } satisfies Record<RequirementState, string>,
  stepKind: { prompt: "Prompt", approval: "Approval", orchestrate: "Subtasks", end: "End" } satisfies Record<StepKind, string>,
  timelineStatus: {
    queued: "Queued",
    running: "Running",
    waiting_for_human: "Waiting for an answer",
    succeeded: "Succeeded",
    failed: "Failed",
    cancelled: "Cancelled",
  } satisfies Record<TaskStatus, string>,
  columns: {
    task: "Task",
    taskGroup: "Task group",
    owner: "Owner",
    taskType: "Task type",
    workflow: "Workflow",
    status: "Status",
    tasks: "Tasks",
    lastPolled: "Last polled",
    currentStep: "Current step",
    cost: "Cost",
    updated: "Updated",
    step: "Step",
    outcome: "Outcome",
    outputs: "Outputs",
    tokens: "Tokens",
    took: "Took",
  },
  cadence: {
    minutes: (m: number) => `Every ${m} min`,
    hour: "Every hour",
    day: "Every day",
    hours: (h: number, m: number) => `Every ${h} h${m > 0 ? ` ${m} min` : ""}`,
  },
  sourceLabels: (labels: string) => `labels ${labels}`,
  ownVm: "Own VM",
  container: "Container",
  notStarted: "Not started",
  live: {
    on: "Live",
    onHint: "Changes appear here as they happen.",
    polling: "Updating every 10 s",
    pollingHint: "Link this browser on the Devices page to see changes as they happen.",
  },
  group,
  cards,
  approvalCard,
  waiting,
  subtasks,
  task,
  toolchains,
  create,
};
